export default __webpack_public_path__ + "static/media/vision-icon.ce115d70.svg";